export default "assets/images/logo-49336c5a.png";